import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useInView } from 'react-intersection-observer';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteUserStatus, USER_CURRENT_KEY, USER_FIL_ACTUALITY_KEY} from "../../../../api/public-voissa/users";
import "./FeedCard.scss";
import {useQuery} from "@tanstack/react-query";
import createLink from "../../../../libs/createLink";
import {
    isNoFollowAlbum,
    isNoFollowProfil,
    genererViews,
    isNoFollowArticle,
    convertDateToStrDuration, legendToTitle
} from "../../../../libs/helper";
import {
    setMediaCountViews,
    MEDIA_SET_COUNT_KEY
} from "../../../../api/public-voissa/medias";
import Avatar from '../../../components/Avatar';
import FeedCardMediaPreview from '../FeedMediaPreview/FeedCardMediaPreview';
import FeedCardMediaLocked from '../FeedMediaLocked/FeedCardMediaLocked';
import Answers from "../../../components/Answers";
import Like from "../../../components/Like/Like";
import Comments from '../../../components/comments/Comments'; 
import { Debug } from '../../../components2/Debug';
import useMediaLocked from '../../../../hooks/useMediaLocked';
import Dotdotdot from 'react-dotdotdot';
import DraftContentReader from '../../../components/editor/DraftContentReader';
import classNames from 'classnames';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretUp,
  faEllipsisVertical
} from "@fortawesome/pro-solid-svg-icons";
import { apiCropImage } from '../../../../config';
import Icon from "../../../components/Icon";
import {Can} from "../../../../ability-context";
import Report from "../../../components/Report";
import Dropdown from "../../../components/Dropdown";
import Modal from "../../../components/Modal";

import Alert from "../../../components/Alert";
import {reportStatus} from "../../../../api/public-voissa/status";
import {toastError, toastSuccess} from "../../../../libs/toast";
import {STATUS} from "../../../../const/toasts";
import {HOME_FEED_FOR_YOU_KEY} from "../../../../api/public-voissa/home-feed";
import EditStatus from "../../EditStatus/EditStatus";
import CertifiedBadge from '../../CertifiedBadge';

const FeedCardOptions = ({
    content,
    deleteContent = () =>{},
    reportContent = () =>{}
    }) =>{

    const [toggleEditStatus , setToggleEditStatus] = useState(false);
    const [toggleAlertDelete , setToggleAlertDelete] = useState(false);

    return (
        <Fragment>
            <Dropdown align="right" className="mt-4" activableComponent={(
                <FontAwesomeIcon icon={faEllipsisVertical}/>
            )}>
                <ul className="dropdown-menu">
                    <Can action={"update"} subject={content} modelName="Status">
                        <li className="menu-item"
                            onClick={() => setToggleEditStatus(true)}>
                            <Icon type="pencil"/> Editer
                        </li>
                    </Can>
                    <Can action={"delete"} subject={content} modelName="Status">
                        <li className="menu-item"
                            onClick={() => setToggleAlertDelete(true)}>
                            <Icon type="close"/> Supprimer
                        </li>
                    </Can>
                    <Can action={"report"} subject={content} modelName="Status">
                        <li className="menu-item">
                            <Icon type="report"/>
                            <Report _id={content?._id}
                                    kind={"status"}
                                    handleReport={(message)=>reportContent({id : content?._id, data : {message}})}
                                    title="le statut"/>
                        </li>
                    </Can>
                </ul>
            </Dropdown>
            <Modal toggle={toggleEditStatus} handleClose={() => setToggleEditStatus(false)}>
                {toggleEditStatus ? <EditStatus key={content._id} statusId={content?._id} userId={content?.owner?._id} handleClose={() => setToggleEditStatus(false)}/> : null}
            </Modal>
            <Modal toggle={toggleAlertDelete}
                   handleClose={() => setToggleAlertDelete(false)}>
                <Alert text="Voulez vous vraiment supprimer ce statut ?"
                       handleDelete={deleteContent}
                       handleClose={() => setToggleAlertDelete(false)}/>
            </Modal>
        </Fragment>
    )
}

const FeedCardHeader = ({publicationOwner, createdAt, secondLineElement, headerActionElement})=>{
    const relLinkProfil = isNoFollowProfil(publicationOwner) ? { rel: "nofollow" } : {};
    return (
        <div className="feed-card-head">
                <Link to={createLink("userProfile", publicationOwner)} {...relLinkProfil}>
                    <Avatar avatar={publicationOwner?.profile?.avatar}
                            height={40}
                            width={40}
                            gender={publicationOwner?.profile?.gender || "guest"}
                            online={publicationOwner?.online}
                            alt=""/>
                </Link>
                <div className="feed-card-head-info-wrapper">
                    <div className='feed-card-head-info-firstline'>
                        <Link to={createLink("userProfile", publicationOwner)} {...relLinkProfil}>
                            {publicationOwner.username} {!!publicationOwner.isCertified && <CertifiedBadge />}
                        </Link>
                        <span className='feed-card-head-info-date'>{convertDateToStrDuration(createdAt)}</span>
                    </div>
                    <div className='feed-card-head-info-secondline'>
                        {secondLineElement}
                    </div>
                </div>
                {headerActionElement}
            </div>
    )
}

const FeedCardBody = ({children, smPadding=false})=>{
    const handleDisabledEvent = (event) => {
        event.preventDefault();
    }
    return (
        <div className={classNames("feed-card-body", {"feed-card-body-sm-padding":smPadding})} onContextMenu={handleDisabledEvent} onDragStart={handleDisabledEvent}>
            {children}
        </div>
    )
}

const FeedCardFooter = ({
    publication,
    publicationType = "medias",
    isLiked = false,
    showComments = false,
    countComment = 0,
    countLikes = 0,
    countViews = 0,
    children
})=>{
    const [toggleComments, setToggleComments] = useState(false);
    const handleToggleComments = useCallback(() => {
        setToggleComments(prevToggle => !prevToggle);
    }, []);

    return (
        <div className="feed-card-foot">
            <div className="feed-card-foot-interaction">
                <span className='feed-card-foot-interaction-likes-comments'>
                    <Answers value={countComment}/>
                    <Like
                        isLiked={isLiked}
                        value={countLikes}
                        likeType={publicationType}
                        parentId={publication._id}
                    />
                </span>
                {publicationType === 'medias' && <span className='feed-card-foot-interaction-views'>{genererViews(countViews)} vues</span>}
            </div>
            {children && (
                <div className="feed-card-foot-content">
                    {children}
                </div>
            )}
            {showComments && (
                <Fragment>
                    <div onClick={handleToggleComments} className='feed-card-foot-toggle-comments'>{toggleComments ? "Masquer les commentaires" : "Voir les commentaires"}</div>
                    {toggleComments && (
                        <Comments
                            className="feed-card-foot-comments-wrapper"
                            type={publicationType}
                            parent={publication}
                            commentsAllowed={publication?.commentsAllowed || publication?.comment?.allowed || false}
                            previewSubComment={2}
                            limit={5}
                        />
                    )}
                </Fragment>
            )}
        </div>
    )
}

export const FeedCardMedia = ({media = {}, parentWidth})=>{
    const [elapsed, setElapsed] = useState(false);
    const [ref, inView] = useInView({
        triggerOnce: false,
        threshold: [0.2]
    });
    const {locked, lockedReason, handleLockedAction} = useMediaLocked(media);
    const timeViewCount = media.kind === "video" ? 2000 : 300;
    
    useEffect(() => {
        let timer;
        if (inView) {
            timer = setTimeout(() => {
                setElapsed(true);
            }, timeViewCount);
        }
        return () => clearTimeout(timer);
    }, [inView, timeViewCount]); 

    const relLinkAlbum = isNoFollowAlbum(media) ? { rel: "nofollow" } : {};
    const relLinkProfil = isNoFollowProfil(media?.owner) ? { rel: "nofollow" } : {};
    useQuery(
        [MEDIA_SET_COUNT_KEY, media._id],
        ()=> setMediaCountViews(media._id),
        {
            staleTime : (1000 * 60 * 60),
            cacheTime : (1000 * 60 * 60),
            retry : false,
            enabled : !!media._id && !locked && elapsed
        }
    );

    return (
        <div className="feed-card" ref={ref}>
            <FeedCardHeader 
                publicationOwner={media?.owner} 
                createdAt={media?.createdAt}
                secondLineElement={<>
                    publié dans {media.owner && media.album && (
                        <Link
                            to={createLink("userCollection", {
                                ...media.owner, album : media.album
                            })} {...relLinkAlbum}>{media && media.album.title}
                        </Link>
                    )}
                </>}
            />
            <FeedCardBody>
                <Debug><pre style={{fontSize:'12px', position:'absolute', background:'#FFF', opacity:'.7', margin:'4px', zIndex:22, padding:'8px'}}>{JSON.stringify(media.scoring, null, 2)}</pre></Debug>
                {locked 
                    ? <FeedCardMediaLocked media={media} lockedReason={lockedReason} handleLockedAction={handleLockedAction} parentWidth={parentWidth}/>
                    : <FeedCardMediaPreview media={media} parentWidth={parentWidth}/> 
                }
            </FeedCardBody>
            <FeedCardFooter
                publication={media}
                publicationType="medias"
                isLiked={media.isLiked}
                showComments={!locked}
                countComment={media.count.comment}
                countLikes={media.count.like}
                countViews={media.count.view}
            >
                <Link to={createLink("userProfile", media.owner)} {...relLinkProfil}>
                    {media.owner.username}
                </Link> {legendToTitle(media?.legend || "")}
            </FeedCardFooter>
        </div>
    )
}

export const FeedCardStatus = ({status = {}})=>{
    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const ownerIsCurrentUser = status?.owner?._id === currentUser?._id;
    const authorIsOwner = status?.owner?._id === status?.author?._id;
    const relLinkProfil = isNoFollowProfil(status?.owner) ? { rel: "nofollow" } : {};

    const userId = status?.owner?._id;
    const {
        mutate : mutateDeleteStatus,
    } = useMutation(() => deleteUserStatus(userId, status?._id),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries([USER_FIL_ACTUALITY_KEY, userId]);
            await queryClient.invalidateQueries([HOME_FEED_FOR_YOU_KEY]);
        },
        onError: () =>{
            toastError(STATUS.ERROR.DELETE);
        }
    });

    const {
        mutate : mutateReportStatus,
    } = useMutation(data => reportStatus(data.id, data.data),{
        onSuccess: () =>{
            toastSuccess(STATUS.SUCCESS.REPORT);
        },
        onError: () =>{
            toastError(STATUS.ERROR.REPORT);
        }
    });

    return (
        <div className="feed-card">
            <FeedCardHeader 
                publicationOwner={status?.author} 
                createdAt={status?.createdAt}
                secondLineElement={<>
                    a publié un statut {!authorIsOwner && (
                    ownerIsCurrentUser 
                    ? `sur votre profil`
                    : <>
                        sur le profil de <Link to={createLink("userProfile", status?.owner)} {...relLinkProfil}>
                            {status?.owner.username}
                        </Link>
                    </>
                    )}
                </>}
                headerActionElement={currentUser?._id ? <FeedCardOptions content={status} deleteContent={mutateDeleteStatus} reportContent={mutateReportStatus} /> : null}
            />
            <FeedCardBody smPadding={true}>
                <div className="feed-card-status-body">
                    <FontAwesomeIcon icon={faCaretUp} className='feed-card-status-body-carret-up'/>
                    <DraftContentReader key={status.updatedAt} contentRaw={status.contentRaw} />
                </div>
            </FeedCardBody>
            <FeedCardFooter
                publication={status}
                publicationType="status"
                isLiked={status.isLiked}
                countComment={status.count.comment}
                countLikes={status.count.like}
                showComments={true}
            />
        </div>
    )
}

export const FeedCardArticle = ({article = {}})=>{
    const link = createLink("article", {...article.owner, article: {_id: article._id, slug: article.slug}});
    const relLink = isNoFollowArticle(article) ? { rel: "nofollow" } : {};
    return (
        <div className="feed-card">
            <FeedCardHeader publicationOwner={article?.owner} createdAt={article?.createdAt} secondLineElement={'a publié un article'}/>
            <FeedCardBody smPadding={true}>
               <Link className="feed-card-article-body" to={link} {...relLink}>
                    {article.cover && <img src={apiCropImage({ url: article.cover, width: '600', quality:90})} alt={article.title}/>}
                    <div className="feed-card-article-title">
                        {article.title}
                    </div>
                    <div className="feed-card-article-excerpt">
                        <Dotdotdot clamp={"10"} useNativeClamp={false}>
                            {article.excerpt}
                        </Dotdotdot>
                    </div>
               </Link>
            </FeedCardBody>
            <FeedCardFooter
                publication={article}
                publicationType="articles"
                isLiked={article.isLiked}
                countComment={article.count.comment}
                countLikes={article.count.like}
                showComments={true}
            />
        </div>
    )
}

const publicationTypeMap = {
    'Media' : 'medias',
    'Status' : 'status',
    'Article' : 'articles'
}

const FeedCard = ({publication, parentWidth})=>{
    const publicationType = publicationTypeMap[publication.publicationType] || 'medias';
    switch (publicationType) {
        case 'medias':
            return <FeedCardMedia media={publication} parentWidth={parentWidth}/>
        case 'status':
            return <FeedCardStatus status={publication}/>
        case 'articles':
            return <FeedCardArticle article={publication}/>
        default:
            return null
    }
    
}

const arePropsEqual = (prevProps, nextProps) => {
    return prevProps?.publication?._id === nextProps?.publication?._id &&
           prevProps?.publication?.updatedAt === nextProps?.publication?.updatedAt &&
           prevProps.parentWidth === nextProps.parentWidth
}

export default React.memo(FeedCard, arePropsEqual);